// header drawer

// const headerDetails = document.querySelector('#Details-menu-drawer-container');

// headerDetails.addEventListener('click', function(){
//     headerDetails.classList.add('menu-opening');
//     headerDetails.setAttribute('aria-expanded', true);
//     headerDetails.setAttribute('open');
// })

document.addEventListener('DOMContentLoaded', function(){
    let buyBtnText = document.querySelector('.cstm-product .product-form__buttons .shopify-payment-button button');
    buyBtnText.innerHTML = "Buy Now";

    // banner section page-width class add
    const pdpBanner = document.querySelector('.cstm-product .banner-main-container ');
    pdpBanner.classList.add('page-width');
})

// variants code
// document.addEventListener("DOMContentLoaded", () => {
//   // function to update selected variant image
//   function updateVariantDisplay(picker) {
//     const selectedInput = picker.querySelector("input:checked") || picker.querySelector("select");
//     let imageUrl = null;
//     let color = null;

//     if (selectedInput.tagName.toLowerCase() === "select") {
//       const selectedOption = selectedInput.selectedOptions[0];
//       imageUrl = selectedOption.dataset.variantImage;
//       color = selectedOption.dataset.variantColor;
//       const displaySpan = picker.querySelector("[data-selected-value]");
//       if (displaySpan) {
//         displaySpan.innerHTML = "";
//         if (imageUrl) {
//           const img = document.createElement("img");
//           img.src = imageUrl;
//           img.alt = selectedOption.text;
//           img.style.width = "24px";
//           img.style.height = "24px";
//           img.style.objectFit = "cover";
//           img.style.borderRadius = "4px";
//           img.style.marginRight = "6px";
//           displaySpan.appendChild(img);
//         } else if (color) {
//           const colorBox = document.createElement("span");
//           colorBox.style.width = "20px";
//           colorBox.style.height = "20px";
//           colorBox.style.borderRadius = "50%";
//           colorBox.style.backgroundColor = color;
//           colorBox.style.display = "inline-block";
//           colorBox.style.marginRight = "6px";
//           displaySpan.appendChild(colorBox);
//         }
//         const textNode = document.createElement("span");
//         textNode.textContent = selectedOption.text;
//         displaySpan.appendChild(textNode);
//       }
//     } else {
//       // For swatches / pills
//       picker.querySelectorAll("input").forEach(input => {
//         const label = picker.querySelector(`label[for='${input.id}']`);
//         if (input.checked) {
//           imageUrl = input.dataset.variantImage;
//           color = input.dataset.variantColor;
//           let imgEl = label.querySelector(".selected-variant-image");
//           if (!imgEl) {
//             imgEl = document.createElement("img");
//             imgEl.classList.add("selected-variant-image");
//             imgEl.style.width = "24px";
//             imgEl.style.height = "24px";
//             imgEl.style.objectFit = "cover";
//             imgEl.style.borderRadius = "4px";
//             imgEl.style.marginRight = "6px";
//             label.prepend(imgEl);
//           }
//           if (imageUrl) imgEl.src = imageUrl;
//           else if (color) imgEl.style.backgroundColor = color;
//         } else {
//           // remove image from unselected
//           const imgEl = label.querySelector(".selected-variant-image");
//           if (imgEl) imgEl.remove();
//         }
//       });
//     }
//   }

//   // Initialize on load
//   document.querySelectorAll(".product-form__input").forEach(picker => {
//     updateVariantDisplay(picker);

//     // Event listeners
//     picker.addEventListener("change", () => updateVariantDisplay(picker));
//   });
// });


// // show image of variant instead of color

// document.addEventListener("shopify:section:load", () => {
//   document.querySelectorAll(".product-form__input--swatch").forEach(swatch => {
//     // Force refresh swatch background when setting toggled
//     swatch.querySelectorAll(".swatch-input__label").forEach(label => {
//       const bg = label.style.backgroundImage || label.style.backgroundColor;
//       label.style.backgroundImage = bg; // trigger repaint
//     });
//   });
// });


document.addEventListener("DOMContentLoaded", () => {
  const variantSelects = document.querySelectorAll("select.select__select");

  variantSelects.forEach((select) => {
    // Create wrapper for selected image
    let wrapper = select.parentNode.querySelector(".dropdown-selected-wrapper");
    if (!wrapper) {
      wrapper = document.createElement("div");
      wrapper.className = "dropdown-selected-wrapper";
      select.parentNode.insertBefore(wrapper, select);
    }

    let img = wrapper.querySelector(".dropdown-selected-image");
    if (!img) {
      img = document.createElement("img");
      img.className = "dropdown-selected-image";
      wrapper.appendChild(img);
    }

    // Function to update image
    const updateImage = () => {
      const selectedOption = select.options[select.selectedIndex];
      const imgUrl = selectedOption.dataset.variantImage;

      if (imgUrl) {
        img.src = imgUrl;
        img.style.display = "inline-block";
      } else {
        img.style.display = "none";
      }
    };

    // Initial load
    updateImage();

    // Listen for dropdown change
    select.addEventListener("change", updateImage);

    // Listen for Shopify variant change event (for pills or external changes)
    document.addEventListener("variant:change", updateImage);
  });
});

// Footer section code 
    const categories = document.querySelectorAll(".footer__blocks-wrapper .footer-block");

    categories.forEach(function(footerCategory) {
        const catHeading = footerCategory.querySelector('h2.footer-block__heading');
        const footerItems = footerCategory.querySelector('.footer-block__details-content');

        if (!catHeading || !footerItems) return;

        catHeading.addEventListener('click', function() {
            if (window.innerWidth <= 749) {
                footerItems.classList.toggle('active');
                const svgArrow = catHeading.querySelector('svg');
                svgArrow?.classList.toggle('rotated');
            }
        });
    });